import { createSlice } from '@reduxjs/toolkit';
import BaseError from 'utils/base-error';
import { createStrapiMediaUrl, ImageModel, useAppSelector } from 'shared';
// eslint-disable-next-line no-restricted-imports
import { fetchCompanyInformationThunk } from 'shared/lib';

export type ContactsBlockState = {
    loaded: boolean
    errors: BaseError[]
    logoImage?: ImageModel
    phone?: string
    email?: string
    address?: {
        name: string,
        latitude: number,
        longitude: number,
    }
    socialMedias: {
        name: string,
        image: ImageModel,
        link: string,
    }[]
}

const initialState: ContactsBlockState = {
    loaded: false,
    errors: [],
    socialMedias: [],
};

// eslint-disable-next-line import/prefer-default-export
export const contactsBlockSlice = createSlice({
    name: 'contactsBlockSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            fetchCompanyInformationThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.logoImage = {
                        url: createStrapiMediaUrl(response.data.data.logoImage.url),
                    };
                    state.phone = response.data.data.phone;
                    state.email = response.data.data.email;
                    state.address = response.data.data.address ? {
                        name: response.data.data.address.name,
                        latitude: response.data.data.address.latitude,
                        longitude: response.data.data.address.longitude,
                    } : undefined;

                    if (response.data.data.socialMedias) {
                        state.socialMedias = response.data.data.socialMedias.map(({
                            name,
                            link,
                            image,
                        }) => ({
                            name,
                            link,
                            image: {
                                url: createStrapiMediaUrl(image?.url),
                            },

                        }));
                    }

                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
    },
});

export const useContactsBlockState = () => useAppSelector((store) => store.contactsBlock);
